import { HiikerMapStyle } from '../../utils/models/MapStyles';

/**
 * The map style URL a flyover should render with: the user's currently-selected map style (pro-aware),
 * matching the recording map / flyover preview. Used by the post-save "Generate 3D flyover" path so it
 * sends a concrete style instead of letting the backend fall back to its default.
 *
 * Kept out of the recordings entrypoint (which runs DOM/side-effect code on import) so the style
 * selection is unit-testable in isolation.
 */
export function flyoverShareStyleUrl(isPro: boolean): string {
  return HiikerMapStyle.getCurrentStyle(isPro).styleUrl;
}
